@if (leerling$ | async; as leerling) {
	<div class="dashboard-afwezigheid">
		<app-filter-bar></app-filter-bar>
		<app-filter-panel
			[defaultFilters]="filters"
			[allFilters]="allFilters()"
			[leerlingselectie]="false"
			(filterExpressionsChange)="filterExpressions.set($event)"
			endpoint="/aanwezigheid"
			[permanentFilterExpressions]="getDashboardFilters(leerling.leerling)"
			[overrideDefault]="getSchooljaarFilterOverride(leerling.schooljaarInfo)"
		></app-filter-panel>
		<section class="dashboard">
			<app-dashboard-header>
				<app-legenda class="cl-header-utility" [attribute]="['aw_is_abs_geoorloofd']"></app-legenda>
			</app-dashboard-header>
			@if (getSchooljaar()) {
				<app-calendar
					[data]="getCalendarData(filterExpressions(), getDashboardFilters(leerling.leerling))"
					[begin]="getBeginDateForSchooljaar()"
					[generateDay]="generateDay"
					data-exportable
				></app-calendar>
			}
		</section>
	</div>
}
